function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 10.75C1.91421 10.75 2.25 11.0858 2.25 11.5V15.5C2.25 16.1904 2.80964 16.75 3.5 16.75H17C17.6904 16.75 18.25 16.1904 18.25 15.5V11.5C18.25 11.0858 18.5858 10.75 19 10.75C19.4142 10.75 19.75 11.0858 19.75 11.5V15.5C19.75 17.0188 18.5188 18.25 17 18.25H3.5C1.98122 18.25 0.75 17.0188 0.75 15.5V11.5C0.75 11.0858 1.08579 10.75 1.5 10.75Z",
  fill: "#249AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 1.25C10.9142 1.25 11.25 1.58579 11.25 2V11.6893L13.9697 8.96967C14.2626 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L11.0303 14.0303C10.7374 14.3232 10.2626 14.3232 9.96967 14.0303L5.96967 10.0303C5.67678 9.73744 5.67678 9.26256 5.96967 8.96967C6.26256 8.67678 6.73744 8.67678 7.03033 8.96967L9.75 11.6893V2C9.75 1.58579 10.0858 1.25 10.5 1.25Z",
  fill: "#249AF3"
});

function SvgDownloadPayHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPayHistoryIcon);
export default __webpack_public_path__ + "static/media/DownloadPayHistoryIcon.49ca361e.svg";
export { ForwardRef as ReactComponent };